import { render, staticRenderFns } from "./EcoPartPrivateCopying.vue?vue&type=template&id=5859aac6"
import script from "./EcoPartPrivateCopying.vue?vue&type=script&lang=js"
export * from "./EcoPartPrivateCopying.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports